import { FEATURE_GATES, FeatureGateKey } from '@src/configs/feature_gates'
import { Environment } from '@src/configs/feature_gates'

// Check if a feature is enabled for the current environment
// we support multiple environments for a feature gate separated by commas
// like: "production,feather_preview" etc
export const isFeatureEnabled = (feature: FeatureGateKey): boolean => {
    const envFeatureGateEnv = process.env.REACT_APP_FEATURE_GATE_ENV?.toUpperCase() || ''
    // Split current env by comma and trim whitespace
    const currentEnvs = envFeatureGateEnv.split(',').map(env => env.trim())

    const enabledEnvs = FEATURE_GATES[feature] || []
    // Check if any of the current environments are enabled
    return currentEnvs.some(env => enabledEnvs.includes(env as Environment))
}
